import { dedupeRepOptions } from "@/analytics/core/rep-scope";
import type { MultiComboboxOption } from "@/components/ui/multi-combobox";
import { fetchReps, fetchTeams } from "@/raw/datasets/queries";
import { buildRawTeamGroups } from "@/raw/lib/team-groups";
import { useQuery } from "@tanstack/react-query";

export function useRawDimensionOptions() {
  return useQuery({
    queryKey: ["raw", "dimensions"],
    queryFn: async () => {
      const [teams, reps] = await Promise.all([fetchTeams(), fetchReps()]);
      return { teams, reps, teamGroups: buildRawTeamGroups(teams) };
    },
    staleTime: 5 * 60_000,
  });
}

export function repOptionsForTeams(
  reps: { id: number; full_name: string; team_id: number }[],
  teamIds: number[],
): MultiComboboxOption[] {
  const scoped = teamIds.length === 0 ? reps : reps.filter((rep) => teamIds.includes(rep.team_id));
  return dedupeRepOptions(scoped);
}
